//

app.vacancies = {

    settings: {
        $searchForm: $('#vacancies-search'),
        searchFormSelector: '#vacancies-search',
        $searchTags: $('.btn[data-functiongroup]'),
        $btnResetSearchForm: $('#vacancies-reset-search'),
        $filterForm : $('#vacancies-filter'),
        filterFormSelector: '#vacancies-filter',
        $btnResetFilterForm: $('#vacancies-reset-filter')
    },

    init: function() {
        app.vacancies.settings.$searchForm.on('submit', app.vacancies.setFilters);
        app.vacancies.settings.$btnResetSearchForm.on('click', app.vacancies.resetFilters);
        app.vacancies.settings.$searchTags.on('click', app.vacancies.setTag);
        app.vacancies.settings.$filterForm.find('select').on('change', app.vacancies.changeFilters);
        app.vacancies.settings.$btnResetFilterForm.on('click', app.vacancies.resetFilters);
    },

    setFilters: function(ev) {

        ev.preventDefault();

        context.submit({
            method: 'setVacancyFilter',
            form: app.vacancies.settings.searchFormSelector,
            onSuccess: function(response) {
                window.location.href = $('#vacancies-search').attr('action');
            },
            onError: function(){
            }
        });
    },
    changeFilters: function(ev){

        ev.preventDefault();

        var fFilter = '';
        var eFilter = '';
        var aFilter = '';
        var lFilter = '';

        if ( app.vacancies.settings.$filterForm.find('[name="vacancy-functiongroup"]').val() !== '' ) {
            fFilter = '[data-functiongroup="' + app.vacancies.settings.$filterForm.find('[name="vacancy-functiongroup"]').val() + '"]';
        }

        /* if ( app.vacancies.settings.$filterForm.find('[name="vacancy-educationlevel"]').val() !== '' ) {
            eFilter = '[data-educationlevel="' + app.vacancies.settings.$filterForm.find('[name="vacancy-educationlevel"]').val() + '"]';
        } */

        /* if ( app.vacancies.settings.$filterForm.find('[name="vacancy-targetaudience"]').val() !== '' ) {
            aFilter = '[data-targetaudience="' + app.vacancies.settings.$filterForm.find('[name="vacancy-targetaudience"]').val() + '"]';
        } */

        if ( app.vacancies.settings.$filterForm.find('[name="vacancy-location"]').val() !== '' ) {
            lFilter = '[data-location*="' + app.vacancies.settings.$filterForm.find('[name="vacancy-location"]').val() + '"]';
        }

        if ( fFilter === '' && eFilter === '' && aFilter === '' && lFilter === '') {
            $('.vacancy-overview-row .c-panel--light').removeClass('hide');
        }
        else {

            $('.vacancy-overview-row .c-panel--light').addClass('hide');

            $('.vacancy-overview-row .c-panel--light' + fFilter + eFilter + aFilter + lFilter).removeClass('hide');
        }

        context.submit({
            method: 'setVacancyFilter',
            form: app.vacancies.settings.filterFormSelector,
            onSuccess: function(response) {
            },
            onError: function(){
            }
        });
    },

    resetFilters: function(ev) {

        ev.preventDefault();

        if ( app.vacancies.settings.$searchForm.length > 0 ) {
            app.vacancies.settings.$searchForm.find('select').val('');
            app.vacancies.settings.$searchForm.trigger('submit');
        }

        if ( app.vacancies.settings.$filterForm.find('select').length > 0 ) {
            app.vacancies.settings.$filterForm.find('select').val('');
            app.vacancies.settings.$filterForm.find('select').first().trigger('change');
        }

    },

    setTag: function(ev) {

        ev.preventDefault();

        var tagValue = $(this).data('functiongroup');

        app.vacancies.settings.$searchForm.find('select').val('');
        app.vacancies.settings.$searchForm.find('select[name="vacancy-functiongroup"]').val(tagValue);
        app.vacancies.settings.$searchForm.trigger('submit');
    }
};